export default __webpack_public_path__ + "static/about-3-58d0fcc9d6a032a0a478e2eda2ef26f8.png";